<template lang="pug">
button.v-btn-modal.btn-modal.page-header__yellow-button.btn.btn--primary.btn--yellow-shadow(v-if="btn" type="button" @click="openForm") Связаться
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			btn: null
		};
	},

	methods: {
		openForm() {
			controller.openModal({
				className: 'modal--sm',
				component: {
					name: 'v-form',
					props: {
						dataSource: this.btn.form,
						media: this.btn.media,
						phones: this.btn.phones,
						className: 'call-back'
					}
				}
			});
		},
		dataSet(data) {
			this.btn = data;
		}
	}
};
</script>
